<template>
  <el-container
    ref="elementBox"
    class="tile-chart-card-element"
  >
    <el-main class="tile-chart-card-element-body">
      <slot name="element-content" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  mounted() {
    this.$emit('update:size',
      {
        elementHeight: (this.$refs.elementBox as Vue).$el.clientHeight,
        elementWidth: (this.$refs.elementBox as Vue).$el.clientWidth
      }
    )
    window.addEventListener('resize', this.browserResized)
    window.addEventListener('transitionend', this.browserResized)
  }

  destroyed() {
    window.removeEventListener('resize', this.browserResized)
    window.removeEventListener('transitionend', this.browserResized)
  }

  private browserResized() {
    this.$emit('update:size',
      {
        elementHeight: (this.$refs.elementBox as Vue).$el.clientHeight,
        elementWidth: (this.$refs.elementBox as Vue).$el.clientWidth
      }
    )
  }
}
</script>

<style lang="scss">
  .tile-chart-card-element {
    display: flex;
    flex: 1;
    height: 100%;
    padding: 0;
    .tile-chart-card-element-body {
      display: inherit;
      padding: 0;
      height: 100%;
    }
  }
</style>
